import React, { useEffect, useState } from 'react';
import { services } from '../data';
import logo from '../assets/laftek.png';
import './Navbar.css';

const navItems = [
  { key: 'home', label: 'Home', href: '/home' },
  { key: 'services', label: 'Support Services', href: '/services' },
  { key: 'ai-careers', label: 'AI & Careers', href: '/ai-careers' },
  { key: 'jobs', label: 'Job Openings', href: '/jobs' },
  { key: 'contact', label: 'Contact', href: '/contact' },
];

const getServiceId = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export default function Navbar({ currentRoute }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setHasScrolled(window.scrollY > 24);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const transparentAtTop = currentRoute === 'home' && !hasScrolled && !menuOpen;

  return (
    <nav className={`navbar ${transparentAtTop ? 'navbar-transparent' : 'navbar-scrolled'}`}>
      <a href="/home" className="navbar-logo" onClick={() => setMenuOpen(false)}>
        <img src={logo} alt="Laftek Business Solutions" className="navbar-logo-image" />
      </a>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <li key={item.key} className={item.key === 'services' ? 'nav-dropdown' : ''}>
            <a
              href={item.href}
              className={currentRoute === item.key ? 'active' : ''}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>

            {item.key === 'services' && (
              <div className="nav-dropdown-menu">
                {services.map((service) => (
                  <a key={service.num} href={`/services?service=${encodeURIComponent(getServiceId(service.title))}`} onClick={() => setMenuOpen(false)}>
                    {service.title}
                  </a>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>

      <div className="nav-contact">
        <a className="nav-phone" href="tel:+917880788799">+91 7880 788 799</a>
        <a className="nav-wa" href="https://wa.me/917880788799" target="_blank" rel="noreferrer">
          WhatsApp
        </a>
      </div>

      <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? 'X' : 'Menu'}
      </button>
    </nav>
  );
}
